import React from 'react';

import { DropdownSVG } from '~/src/assets/icons';

import { useHandlerAdapter } from './select.helpers';
import {
  SelectArrow,
  SelectBox,
  SelectField,
  SelectIcon,
} from './select.styles';
import { SelectProps } from './select.types';

export function Select(props: SelectProps): JSX.Element | null {
  const {
    boxRef,
    fieldRef,
    icon,
    name,
    value,
    options,
    placeholder,
    isDisabled,
    isErrored,
    onChange,
    onFocus,
    onBlur,
    ...rest
  } = props;

  const onChangeHandler = useHandlerAdapter(onChange);
  const onFocusHandler = useHandlerAdapter(onFocus);
  const onBlurHandler = useHandlerAdapter(onBlur);

  return (
    <SelectBox {...rest} ref={boxRef}>
      <SelectField
        ref={fieldRef}
        name={name}
        value={value}
        placeholder={placeholder}
        disabled={isDisabled}
        $isErrored={isErrored}
        $hasValue={Boolean(value)}
        onChange={onChangeHandler}
        onFocus={onFocusHandler}
        onBlur={onBlurHandler}
      >
        {placeholder && (
          <option value="">
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </SelectField>
      {icon && (
        <SelectIcon>
          {icon}
        </SelectIcon>
      )}
      <SelectArrow>
        <DropdownSVG />
      </SelectArrow>
    </SelectBox>
  );
}
